<div class="image-dialog__top p-6 p-3-sm" [attr.data-testid]="imageDialog">
    <button
        id="close-dialog-button"
        mat-icon-button
        [attr.data-testid]="imageDialogCloseButton"
        (click)="closeImageDialog()"
        class="popup-dialog__button"
        [attr.aria-label]="'Luk dialog'"
        [attr.aria-hidden]="false"
        [attr.tabindex]="0"
        role="button"
        type="button"
    >
        <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
</div>

<img [src]="data.activeImageSrc" [attr.data-testid]="imageDialogActiveImage" class="preview" alt="" />
